module.exports = "pegasus/assets/graycircle-twitter.png";